import React from 'react';
import PlateHeatmap from '../../components/biology/PlateHeatmap';

const PlateHeatmapDemo: React.FC = () => {
  return <PlateHeatmap />;
};

export default PlateHeatmapDemo;
